import React, { useEffect } from 'react';
import { Box, Typography } from '@mui/material';
import Navigation from '../../components/Navigation/Navigation';
import { ApiGetApplications } from '../../../stores/api/application/actions';
import ApplicationCard from '../../components/ApplicationCard/ApplicationCard';
import { FromStore } from '../../../helpers/Store';
import { useLocation } from 'react-router-dom';
import { CenteredContainer } from '../../../style/GlobalsComponentsStyled';
import { useAppDispatch } from '../../../helpers/UseAppDispatch';
import { ApplicationData } from '../../../api/dtos/application/ApplicationResponse';

const DashboardPage: React.FC = () => {
    const dispatch = useAppDispatch();
    const applications: ApplicationData[] = FromStore(state => state.apis.applications.applications);
    const Location = useLocation();
    const selectedGame = Location.state?.game || null;

    useEffect(() => {
        dispatch(ApiGetApplications());
    }, [dispatch]);

    const filteredApplications = selectedGame
        ? applications.filter(app => app.game === selectedGame)
        : applications;

    return (
        <>
            <Navigation />
            <CenteredContainer className='main_content'>
                <Box display='flex' flexWrap='wrap' justifyContent='center' gap='1rem' width='100%'>
                    {filteredApplications && filteredApplications.length > 0 ? (
                        filteredApplications.map((application, index) => (
                            <Box key={index} sx={{ width: { xs: '100%', md: '48%' }, minWidth: 275, maxWidth: 700 }} >
                                <ApplicationCard id={application.id} name={application.name} description={application.description} httpLogin={application.httpLogin} version={application.version} percentage={application.percentage} lastUpdate={application.lastUpdate} />
                            </Box>
                        ))
                    ) : (
                        <Typography>No applications found.</Typography>
                    )}
                </Box>
            </CenteredContainer>
        </>
    );
};

export default DashboardPage;